import { useEffect, useState } from "react";
import clsx from "clsx";
import ProgressiveImage from "react-progressive-graceful-image";
import { Grid, makeStyles } from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  imgContainer: {
    borderRadius: 45,
    overflow: "hidden",
    position: "relative",
    userSelect: "none",
    width: "inherit",
    height: "inherit",
  },
  imgHigh: {
    width: "100%",
    height: "auto",
  },
  imgLong: {
    width: "auto",
    height: "100%",
  },
}));

interface IProps {
  file?: File;
  className?: string;
  size?: number | string;
}

const Avatar = ({ file, className = "", size = "1rem" }: IProps) => {
  const classes = useStyles();
  const [urlImage, setUrlImage] = useState("");
  const [imageIsLong, setImageIsLong] = useState(false);

  useEffect(() => {
    if (file) readerFile(file);
    else setUrlImage("");
  }, [file]);

  const handleLoadImage = (ev) => {
    const el = ev.target as Element;
    setImageIsLong(el.clientWidth > el.clientHeight);
  };

  function readerFile(file: File) {
    const reader = new FileReader();
    reader.onloadend = function () {
      setUrlImage(reader.result as any);
    };
    reader.readAsDataURL(file);
  }

  if (!urlImage) {
    return (
      <AccountCircle
        className={className}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <Grid
      container
      item
      xs
      justifyContent="center"
      className={clsx(classes.imgContainer, className)}
      style={{ width: size, height: size }}
    >
      <ProgressiveImage src={urlImage} placeholder="tiny-image.jpg">
        {(src, loading) => (
          <img
            id="imgProfileAvatarImage"
            src={src}
            className={clsx({
              [classes.imgLong]: imageIsLong,
              [classes.imgHigh]: !imageIsLong,
            })}
            alt=""
            style={{ position: "absolute", opacity: loading ? 0.5 : 1 }}
            onLoad={handleLoadImage}
          />
        )}
      </ProgressiveImage>
    </Grid>
  );
};

export default Avatar;
